import classNames from 'classnames';
import ChevronDownIcon from '../../../../assets/icons/chevron-up.svg';
import styles from './minimize-button.module.css';

interface MinimizeButtonProps {
    isFixed: boolean;
    closeMaxiPlayer: () => void;
}

export function MinimizeButton({ isFixed, closeMaxiPlayer }: MinimizeButtonProps) {
    return (
        <div className={styles['minimize-button__container']}>
            <button
                aria-label="Switch to mini player"
                onClick={closeMaxiPlayer}
                className={classNames(styles['minimize-button__button'], {
                    [styles['minimize-button__button--scrolled']]: isFixed,
                })}
                type="button"
            >
                <span className={classNames(styles['minimize-button__button-label'])}>Minimize</span>
                <span className={classNames(styles['minimize-button__button-icon'])}>
                    <ChevronDownIcon />
                </span>
            </button>
        </div>
    );
}
